import React from 'react';

const Client = () => {
  const colleges = [
    { name: 'Balwant College, Sangali', logo: '/Images/Balwant_College_Sangali.png' },
    { name: 'Dravid High School, Vai', logo: '/Images/Dravid_High_School_Vai.png' },
    { name: 'Kalnyani High School', logo: '/Images/Kalnyani_High_School.png' },
    { name: 'KBP College', logo: '/Images/KBP.png' },
    { name: 'LBS College, Satara', logo: '/Images/LBS_College_Satara.png' },
    { name: 'Maharaja Saiyyaji, Satara', logo: '/Images/Maharaja_Saiyyaji_Satara.png' },
    { name: 'Mahila Mahavidyalay, Ubraj', logo: '/Images/Mahila_Mahavidyalay_Ubraj.png' },
    { name: 'New English School, Satara', logo: '/Images/New_English_School_Satara.png' },
    { name: 'SGM College, Karad', logo: '/Images/SGM_College_Karad.png' },
    { name: 'YC College, Satara', logo: '/Images/YC_College_Satara.png' },
  ];

  const loopedColleges = [...colleges, ...colleges]; // Doubled for seamless loop

  return (
    <div className="w-full bg-white py-4 overflow-hidden">
      {/* Title */}
      <div
        className="text-center text-4xl font-bold mb-12 py-8 w-full"
        style={{ backgroundColor: '#4CAF50', color: 'white' }}
      >
        25+ years of Trust and Co-operation
      </div>

      {/* Scrolling Logo Strip */}
      <div className="relative overflow-hidden">
        <div className="flex animate-marquee space-x-8 px-4">
          {loopedColleges.map((college, index) => (
            <div
              key={index}
              className="group relative flex-shrink-0 h-32 w-32 md:h-36 md:w-36 bg-white rounded-xl shadow-lg overflow-hidden hover:scale-105 transition-transform duration-300"
            >
              <img
                src={college.logo}
                alt={college.name}
                className="w-full h-full object-contain"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white text-xs text-center py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                {college.name}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Tailwind Custom Keyframes */}
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          display: flex;
          width: max-content;
          animation: marquee 40s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default Client;
